import axios from 'axios';
import { IActionMetadata } from '@tymely/atoms';

export const listActionsMetadata = async () =>
    await axios.get<{ results: IActionMetadata[] }>('action-metadatas/list', { params: {limit: 1000} })
        .then(res => res.data?.results);
